import React, { useState } from 'react';
import PropTypes from 'prop-types';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import HoursDay from 'bento-ordering/locations/components/HoursDay';
import { styled } from '@mui/system';
import { getSectionNavLightColor } from 'styles/helpers/getThemeStyles';

const iconFill = ({ theme }) => ({
  fill: getSectionNavLightColor(theme)
});
export const StyledKeyboardArrowUp = styled(KeyboardArrowUp)(iconFill);

export const StyledKeyboardArrowDown = styled(KeyboardArrowDown)(iconFill);

const Hours = ({ label, aboveTheFoldHours, belowTheFoldHours }) => {
  const [isOpen, toggleOpen] = useState(false);
  const Icon = isOpen ? StyledKeyboardArrowUp : StyledKeyboardArrowDown;
  const ToggleHoursButton = (
    <IconButton
      data-testname="toggle-hours"
      aria-label="toggle-week-display-hours"
      onClick={() => toggleOpen(!isOpen)}
      sx={{ padding: 0 }}
    >
      <Icon />
    </IconButton>
  );
  const todayAdornment = !isOpen ? ToggleHoursButton : undefined;
  return (
    <div>
      <HoursDay
        label={label}
        hours={aboveTheFoldHours}
        adornmentEnd={todayAdornment}
        dataTestId="today-display-hours"
      />

      <Collapse in={isOpen}>
        <List>
          {belowTheFoldHours.map((dayRange, idx, arr) => {
            const isLast = idx === arr.length - 1;
            const adornmentEnd = isLast ? ToggleHoursButton : undefined;
            return (
              <ListItem key={dayRange.days} dense sx={{ display: 'block' }}>
                <HoursDay
                  dataTestId="week-display-hours"
                  label={dayRange.days}
                  hours={dayRange.hours}
                  adornmentEnd={adornmentEnd}
                />
              </ListItem>
            );
          })}
        </List>
      </Collapse>
    </div>
  );
};

Hours.propTypes = {
  label: PropTypes.string.isRequired,
  aboveTheFoldHours: PropTypes.array.isRequired,
  belowTheFoldHours: PropTypes.array.isRequired
};

export default Hours;
